var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };} /** @format */

import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { IconSelector } from "../../ReactReduxForms";
import { actions } from "./..";
import { FormValue } from "../../Forms";
import ToggleDisplay from "../../Layout/ToggleDisplay";
import { bindActionCreators } from 'redux';
import { Translate } from "../../I18N";
import { Icon } from "../../UI";

export const IconFieldBase = ({ model, removeIcon }) => /*#__PURE__*/
_jsx(FormValue, { model: `${model}.icon` }, void 0,
(icon = {}) => /*#__PURE__*/
_jsx("div", { className: "icon-selector" }, void 0, /*#__PURE__*/
_jsx(ToggleDisplay, {
  showLabel: /*#__PURE__*/
  _jsx("span", {}, void 0, /*#__PURE__*/
  _jsx(Translate, {}, void 0, "add icon"), /*#__PURE__*/
  _jsx(Icon, { icon: "eye" })
  ),

  hideLabel: /*#__PURE__*/
  _jsx("span", {}, void 0, /*#__PURE__*/
  _jsx(Translate, {}, void 0, "remove icon"), /*#__PURE__*/
  _jsx(Icon, { icon: "eye-slash" })
  ),

  onHide: () => removeIcon(`${model}.icon`),
  open: !!icon._id }, void 0, /*#__PURE__*/

_jsx("ul", { className: "search__filter" }, void 0, /*#__PURE__*/
_jsx("li", {}, void 0, /*#__PURE__*/
_jsx("label", {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Icon"), " / ", /*#__PURE__*/_jsx(Translate, {}, void 0, "Flag")
)
), /*#__PURE__*/
_jsx("li", { className: "wide" }, void 0, /*#__PURE__*/
_jsx(IconSelector, { model: ".icon" })
)
)
)
)

);







function mapDispatchToProps(dispatch) {
  return bindActionCreators({ removeIcon: actions.removeIcon }, dispatch);
}

export const IconField = connect(null, mapDispatchToProps)(IconFieldBase);